import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        user_id: String,
    }

    close() {
        console.log('tab content', this.userIdValue)
        this.dispatch("close", { detail: { content: this.userIdValue } })
    }
}
